declare const __RONIN_VERSION__: string;

/** spec07: the version this web build came from (vite.config.ts). */
export const APP_VERSION = __RONIN_VERSION__;
